export const versionToNumber = (version: string) => {
    const versionParts = version.split('.');
    let ver = 0;

    versionParts.forEach((chunk, i) => {
        ver += Number(chunk) * (10 ** 4) ** (versionParts.length - 1 - i);
    });

    return ver;
};

export const isVersionLater = (version: string, thanVersion: string) => {
    return versionToNumber(version) > versionToNumber(thanVersion);
};
